import React from 'react'
import { Section } from '../../components/Section'
import { SectionContentImageWithText } from '../../components/SectionContentImageWithText'

export const SectionContentInstanceMaraSignals: React.FunctionComponent =
  () => (
    <Section backgroundColor="white" padding={100}>
      <SectionContentImageWithText
        heading="Powered by real-time signals"
        description={{
          description:
            'Trained on 2.5M+ hospitality shifts (and counting), Mara ensures every shift is filled with the right talent at the right time. She learns your unique preferences and considers all inputs to seamlessly pair your open shifts with perfectly matched professionals.',
        }}
        imagePlacement="left"
        image={{
          publicId: 'photography/mara-img-signals',
          alt: 'Mara signals',
        }}
        showAppStoreLinks={false}
      />
    </Section>
  )
